import { useGetIntakeformsIntakeFormTemplateId } from '@/api/generated/intake-form-template/intake-form-template'
import { mapIntakeFormError } from './mapIntakeFormError'

/**
 * Reads a single intake form by id. Replaces the `getIntakeFormById` thunk +
 * GET_INTAKE_FORM_BY_ID* reducer flow (the per-id `intakeFormData[id]` cache, loading, and
 * the listener's setLoading / setError side effects).
 *
 * The generated query is disabled while `id` is empty (matching the old `if (id) dispatch`
 * guard). `error` mirrors the listener/reducer mapping so the not-found message — which the
 * view watches to navigate back to Management — is byte-for-byte the same.
 */
export const useIntakeForm = (id: string) => {
  const query = useGetIntakeformsIntakeFormTemplateId(id)
  const error = query.error ? mapIntakeFormError(query.error) : ''

  return { ...query, intakeForm: query.data, loading: query.isLoading, error }
}
